import React from 'react';
import { Product } from '@portal/portal-core';
import { withTheme } from 'styled-components';
import type { DefaultTheme } from 'styled-components';

import { fjButtonTypes } from 'components/primitives';
import type { FjButtonType } from 'components/primitives/fj-button';
import { productInfo } from 'constants/products';
import { UserClientActions } from 'ducks/user-client';
import { selectCurrentUser, selectLicenseStatus } from 'selectors';
import theme from 'styles/theme';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import BaseButton from './base-button';

const { NAMES_UI_TABS } = Product;

interface RenewButtonProps {
  product: string;
  buttonType?: FjButtonType;
  theme?: DefaultTheme;
}

// `analyzeLicense` (cloud-core) types these fields as `any`; capture the fields we read.
interface ProductLicenseInfo {
  id: string;
  costCenterId: string;
}

const RenewButton = ({ product, buttonType }: RenewButtonProps): React.JSX.Element | null => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const currentUser = useAppSelector(selectCurrentUser);
  const licenseStatus = useAppSelector(selectLicenseStatus);
  const dispatch = useAppDispatch();

  const baseUrl = productInfo(product)!.links.renew;

  const handleClick = (): void => {
    const { id: userId, primaryEmail } = currentUser;
    const { id: productAccessId, costCenterId } = (licenseStatus.productLicenseInfo ||
      {}) as ProductLicenseInfo;
    const payload = UserClientActions.authcodeRedirect({
      baseUrl: baseUrl!,
      userId,
      primaryEmail,
      product,
      productAccessId,
      costCenterId,
    });
    dispatch(payload);
  };
  // hide by default until FlowJo Hub is ready
  // enable for testing by adding the following param to the url: &renewal-button=true
  if (urlParams.get('renew-button')) {
    return (
      <BaseButton
        onClick={handleClick}
        buttonType={buttonType}
        defaultStyle={{
          color:
            buttonType === fjButtonTypes.LINK ? theme.colors.selectableLightBg : theme.colors.white,
          background: theme.colors.accentButton,
          borderColor: theme.colors.accentButton,
        }}
        hoverStyle={{
          color: theme.colors.white,
          background: theme.colors.accentButtonRollover,
          borderColor: theme.colors.accentButtonRollover,
        }}
      >
        <span>Renew License</span>
      </BaseButton>
    );
  }
  return null;
};

export default withTheme(RenewButton);
